// extracted by mini-css-extract-plugin
module.exports = {"column":"Button_column__3do_O","content":"Button_content__3aKnN","icon":"Button_icon__1OfSC","tooltip":"Button_tooltip__3q1f3"};